import styles from './company-requests.module.scss';
import { Box, Container, OrderTypesEnum, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useGetRequestNewHook } from '../../requestUtils';
import { useState } from 'react';
import PageTitle from '../../page-title/page-title';
import UsersWithoutCompany from '../../users-without-company/users-without-company';

import CompanyRequestsGrid from '../company-requests-grid/company-requests-grid';
import CompanyRequestsGridSkeleton from '../company-requests-grid/company-requests-grid-skeleton';
// import UnregisteredUsersGrid from '../unregistered-users-grid/unregistered-users-grid';
import { INewCompanyRequest } from '../../_models/new-company-request';
import { useTranslation } from 'react-i18next';
import { UseSignalRHook } from '../../signalr-context/signalr-context';

/* eslint-disable-next-line */
export interface CompanyRequestsProps { }

export function CompanyRequests(props: CompanyRequestsProps) {
  const { t } = useTranslation();
  const { data: companyRequests, getData }: { data: INewCompanyRequest[], getData: () => void } = useGetRequestNewHook(`admin/newCompanyRequests`, []);

  UseSignalRHook(getData, [OrderTypesEnum.AcceptCompanyRequestOrder, OrderTypesEnum.RejectAccess]);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.requests")} subtitle={`(${t("standard.admin")})`} />
            {!companyRequests ?
              <CompanyRequestsGridSkeleton /> :
              <CompanyRequestsGrid companyRequests={companyRequests} getCompanyRequests={getData} />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default CompanyRequests;